/* @flow */
/* eslint-disable react/require-extension */
// Bootstrap environment
require('babel-polyfill');
window.Promise = require('./configureBluebird');
require('./main');



// WEBPACK FOOTER //
// ./src/browser/index.js